import {HttpModelConverter} from '../../../../core/converter/httpModel.converter';
import {LovValueSummaryConverter} from '../../../../common/lov/lov-value/api/converter/LovValueSummary.converter';
import {PartnerTypeSummaryModel} from '../model/partnerTypeSummary.model';

export class PartnerTypeSummaryConverter extends HttpModelConverter<PartnerTypeSummaryModel>{
    protected createInstance(): PartnerTypeSummaryModel {
        return new PartnerTypeSummaryModel();
    }

    protected enrichObject(result: PartnerTypeSummaryModel, src: PartnerTypeSummaryModel) {
        result.type = new LovValueSummaryConverter().convert(src.type);
    }
}
